import * as React from 'react';
import {
  GDSSpaceToken,
  spacingTokenMap,
  GDSBreakpoint,
} from '@leagueplatform/genesis-core';
import {
  SidebarLayout,
  GDSSidebarSides,
  GDSSidebarSizes,
} from '@leagueplatform/genesis-core-alpha';
import {
  MasonryEngineNode,
  type MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import { formatClassNames } from '../../utils/format-masonry-class-name.util';

export interface MasonrySidebarLayoutNodeProperties {
  sidebarSide?: GDSSidebarSides;
  sidebarSize?: GDSSidebarSizes;
  spacing?: GDSSpaceToken;
  verticalBreakpoint?: GDSBreakpoint;
}

export type MasonrySidebarLayoutNode = MasonryEngineNode<
  'sidebarLayout',
  MasonrySidebarLayoutNodeProperties,
  {},
  {
    items: MasonryEngineNode<string, any>[];
  }
>;

export type MasonrySidebarLayoutRendererProps =
  MasonryEngineNodeRendererProps<MasonrySidebarLayoutNode>;

export const MasonrySidebarLayoutRenderer = ({
  items,
  spacing: spacingToken = 'one',
  sidebarSide,
  sidebarSize,
  verticalBreakpoint,
  rootElementRef,
  className,
  engineClassName,
  locatorId,
  css,
}: MasonrySidebarLayoutRendererProps) => {
  if (!items || !items.length) return null;
  const spacing = spacingTokenMap[spacingToken];

  return (
    <SidebarLayout
      spacing={spacing}
      sidebarSide={sidebarSide}
      sidebarSize={sidebarSize}
      verticalBreakpoint={verticalBreakpoint}
      ref={rootElementRef}
      className={formatClassNames(engineClassName, className)}
      data-testid={locatorId}
      css={css}
    >
      {items}
    </SidebarLayout>
  );
};
